import React from "react"
import { EScheduleListType, IScheduleBudgetDay, ISchedulePatternTemplate, IScheduleDocument, IScheduleDailyTimelineData, IScheduleShift, IJobDocument, IClientDocument } from "../../../../models"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import autobind from "class-autobind"
import { lightBlue400, grey300, grey400, grey700 } from "material-ui/styles/colors"
import ScheduleTimeinfoDetailDayView from "./ScheduleTimeinfoDetailDayView"
import moment from "moment"
import * as timeHelper from "../../../../helpers/timeHelper"
import DonutChart from "../../../common/donutChart/DonutChart"
import strings from "../../../../localization/strings"
import ScheduleTimeinfoDailyBudget from "./ScheduleTimeinfoDailyBudget"
import AccountStore from "../../../../stores/AccountStore"
import { Toggle, IconButton, FontIcon } from "material-ui"
import * as utils from "../../../../helpers/utils"
import _ from "lodash"
import WorkInstructions from "../../../work_instructions/WorkInstructions"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import Copy from "../../../../../assets/icons/copy"
import DeleteForeverIcon from "material-ui/svg-icons/action/delete-forever"
import ScheduleTimeinfoDetailWeekViewDayActionIcon from "./ScheduleTimeinfoDetailWeekViewDayActionIcon"
import AppStateStore from "../../../../stores/AppStateStore"

interface IProps {
  type: EScheduleListType
  schedule: IScheduleDocument
  readonly: boolean
  allowDragDrop: boolean
  handleAssignEmployee(assignPatternTemplate: ISchedulePatternTemplate): void
  handleUpdateTimelineData(timelineItem: IScheduleDailyTimelineData, shiftTemplate: IScheduleShift): void
  checkValidateNewTimeline(timelineItem: IScheduleDailyTimelineData, updateShiftTemplate: IScheduleShift, patternTemplate: ISchedulePatternTemplate): boolean
  handleDeleteTimelineItem(deleteShiftTemplate: IScheduleShift): void
  handleDeletePatternTemplates(patternTemplates: ISchedulePatternTemplate[]): void
  handleUpdateTimelineItem(item: IScheduleShift): void
  handleAddShiftTemplate(patternTemplate: ISchedulePatternTemplate): void
  handleShowTimecardPopup(employeeId: string, referenceDate: Date | string): void
  handleUnAssignEmployee(patternTemplate: ISchedulePatternTemplate): void
  handleDragPatternTemplate(dragDropPatternTemplateId: string, moveUp: number, reorderItems: ISchedulePatternTemplate[]): void
  handleDropPatternTemplate(): void
  handleUpdateDailyBudget(dailyBudget: IScheduleBudgetDay, dayIndex: number): void
  handleAutoAddShifts(shifts: ISchedulePatternTemplate[]): void
  handleOpenCloneDialog(candidateClonePatternTemplates: ISchedulePatternTemplate[], cloneDay: number): void
  handleOpenDelayDialog(delayDay: number): void
  handleDeleteEmptyExtraDay(cb: () => void): void
  // if job has start/end date, cannot add out of job date range. for it, we will use this function
  handleAddShiftDisabled(selectedWeekDay: number): void
  handleAddAdditionalDay(): void
  // allow to edit by Tab
  allowQuickEditTime: boolean
  scheduleJob: IJobDocument
  scheduleClient: IClientDocument
}

interface IState {
  selectedDay: number
  showScheduleTimeinfoDetailDayView: boolean
  selectedDayBudget: IScheduleBudgetDay
  excludeNonProductive: boolean
}

export default class ScheduleTimeinfoDetailWeekView extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      selectedDay: 0,
      showScheduleTimeinfoDetailDayView: true,
      selectedDayBudget: this.getDailyBudgetData(0),
      excludeNonProductive: false,
    }
    autobind(this)
  }

  componentDidMount() {
    this.props.handleAddShiftDisabled &&
      this.props.handleAddShiftDisabled(this.state.selectedDay)
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevState.selectedDay !== this.state.selectedDay) || (prevProps.schedule.StartDate !== this.props.schedule.StartDate)) {
      this.props.handleAddShiftDisabled &&
        this.props.handleAddShiftDisabled(this.state.selectedDay)
    }
  }


  get7DaysBySelectedDay(selectedDay: number, dayLength: number): number[] {
    const sevenDays: number[] = []
    const startDay = Math.floor(selectedDay / 7) * 7
    let endDay = Math.floor(selectedDay / 7) * 7 + 6
    endDay = dayLength - 1 > endDay ? endDay : dayLength - 1
    for (let i = startDay; i <= endDay; i++) {
      sevenDays.push(i)
    }
    return sevenDays
  }

  getDailyBudgetData(selectedDay) {
    let selectedDailyBudget = undefined
    if (this.props.schedule.Budget) {
      selectedDailyBudget = this.props.schedule.Budget.Days[selectedDay]
      if (!selectedDailyBudget) {
        selectedDailyBudget = { Date: moment(this.props.schedule.StartDate).utc().startOf("day").add(selectedDay, "days").toDate(), BudgetPositions: [] }
      }
    }

    return !this.props.schedule.Budget ? undefined : selectedDailyBudget
  }

  handleChangeSelectedDay(selectedDay: number) {
    this.setState(
      {
        selectedDay,
        showScheduleTimeinfoDetailDayView: false,
        selectedDayBudget: this.getDailyBudgetData(selectedDay),
      },
      () => this.setState({ showScheduleTimeinfoDetailDayView: true }))
  }

  render() {
    const dayLength = scheduleHelper.getDayLengthFromStartAndEndTime(this.props.schedule.StartDate, this.props.schedule.EndDate)
    const sevenDaysForSelectedDay = this.get7DaysBySelectedDay(this.state.selectedDay, dayLength)
    const patternTemplatesForDay = scheduleHelper.getPatternTemplatesForDay(this.props.schedule.StartDate, this.state.selectedDay, this.props.schedule.Schedules)
    const delaysForDay = scheduleHelper.getDelaysForDay(this.props.schedule.StartDate, this.state.selectedDay, this.props.schedule.Delays)
    const filledPercentArrayForSevenDays = scheduleHelper.getFilledPercentArrayForDays(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate), sevenDaysForSelectedDay, this.props.schedule.Schedules)
    if (AccountStore.getMedicalAccount()) {
      if (this.props.schedule.Budget && this.props.schedule.Budget.Days) {
        let index = 0
        this.props.schedule.Budget.Days.forEach(day => {
          filledPercentArrayForSevenDays[index] = day.FillRateInfo ? Math.round(day.FillRateInfo.FillRate * 100) : 0
          index++
        })
      }
    }

    const donutChartValueLabel = strings.Filled.toUpperCase()

    return (
      <div style={{ position: "relative" }}>
        <div style={{ position: "absolute", top: -35 }}>
          <div style={{ display: "flex" }}>
            <div style={{ marginTop: 7, width: 290, marginRight: 5 }}>
              {dayLength > 7 && [
                <i
                  key="LeftArrow"
                  className={`fa fa-arrow-circle-left ${sevenDaysForSelectedDay[0] > 0 && "TimeActionBarArrow"}`}
                  style={{ color: "#aaaaaa" }}
                  onClick={() => sevenDaysForSelectedDay[0] > 0 && this.handleChangeSelectedDay(sevenDaysForSelectedDay[0] - 7)}
                />,
                <span
                  key="Day"
                  style={{ fontSize: 15, display: "inline-block", width: 260, textAlign: "center" }}
                >
                  {sevenDaysForSelectedDay.length > 1 ?
                    `${moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).add(sevenDaysForSelectedDay[0], "day").format("ddd MMM.DD, YYYY")} - ${moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).add(sevenDaysForSelectedDay[sevenDaysForSelectedDay.length - 1], "day").format("ddd MMM.DD, YYYY")}` :
                    `${moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).add(sevenDaysForSelectedDay[0], "day").format("ddd MMM.DD, YYYY")}`
                  }
                </span>,
                <i
                  key="RightArrow"
                  className={`fa fa-arrow-circle-right ${sevenDaysForSelectedDay[sevenDaysForSelectedDay.length - 1] < dayLength - 1 && "TimeActionBarArrow"}`}
                  style={{ color: "#aaaaaa" }}
                  onClick={() => sevenDaysForSelectedDay[sevenDaysForSelectedDay.length - 1] < dayLength - 1 && this.handleChangeSelectedDay(sevenDaysForSelectedDay[0] + 7)}
                />
              ]}
            </div>
            {dayLength > 1 &&
              <div style={{ display: "flex" }}>
                {sevenDaysForSelectedDay.map((day, i) =>
                  <div style={{ position: "relative" }} key={day}>
                    <div style={{ position: "absolute", top: -53, left: 0, right: 0 }}>
                      {!Number.isNaN(filledPercentArrayForSevenDays[day]) &&
                        <DonutChart
                          value={filledPercentArrayForSevenDays[day]}
                          strokeWidth={4}
                          size={50}
                          valuelabel={donutChartValueLabel}
                          textValStyle={{ fontSize: 12 }}
                          percentStyle={{ fontSize: 10 }}
                          textLabelStyle={{ fontSize: donutChartValueLabel.length > 7 ? 6 : 8 }}
                          spaceBetweenValAndLabel={donutChartValueLabel.length > 7 ? 10 : 12}
                        />
                      }
                    </div>
                    <div
                      data-intercom-target={`Schedule-WeeklySchdule-SelectDay${i + 1}`}
                      key={day}
                      style={{
                        backgroundColor: this.state.selectedDay === day ? lightBlue400 : grey300,
                        color: this.state.selectedDay === day && "white",
                        border: "1px solid",
                        borderColor: this.state.selectedDay === day ? lightBlue400 : grey400,
                        width: 65, height: 30, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                        position: "relative"
                      }}
                      onClick={() => this.handleChangeSelectedDay(day)}
                    >
                      <span>
                        {this.props.schedule.MasterSchedule ?
                          dayLength === 7 ?
                            moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).add(day, "day").format("ddd") :
                            sevenDaysForSelectedDay[i] + 1 :
                          moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).add(day, "day").format("ddd DD")
                        }
                      </span>
                      {this.state.selectedDay === day &&
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule) &&
                        <ScheduleTimeinfoDetailWeekViewDayActionIcon
                          handleClone={
                            patternTemplatesForDay.length > 0 &&
                              this.props.type !== EScheduleListType.Master ?
                              () => this.props.handleOpenCloneDialog(patternTemplatesForDay, this.state.selectedDay) :
                              null
                          }
                          handleDelay={
                            patternTemplatesForDay.length > 0 &&
                              this.props.type === EScheduleListType.Master ?
                              () => this.props.handleOpenDelayDialog(this.state.selectedDay) :
                              null
                          }
                          handleDeleteExtraDay={
                            dayLength - 1 === day &&
                              [EScheduleListType.Planner, EScheduleListType.Posted, EScheduleListType.Master].includes(this.props.type) ?
                              () => patternTemplatesForDay.length > 0 ?
                                AppStateStore.setAlertDialogContent({ content: strings.Day_cannot_be_deleted_because_shifts_are_scheduled }) :
                                this.props.handleDeleteEmptyExtraDay(() => this.handleChangeSelectedDay(dayLength - 2)) :
                              null
                          }
                        />
                      }
                    </div>
                  </div>
                )}
                {dayLength === (sevenDaysForSelectedDay[sevenDaysForSelectedDay.length - 1] + 1) && dayLength < 30 &&
                  <IconButton
                    data-intercom-target={"Btn-Open-Job-Selection-Dialog"}
                    style={{ height: 30, width: 30, padding: 3, marginLeft: 10 }}
                    iconStyle={{ color: grey700, fontSize: 24 }}
                    onTouchTap={this.props.handleAddAdditionalDay}
                  >
                    <FontIcon className="fa fa-plus-circle" />
                  </IconButton>
                }
              </div>
            }
          </div>
        </div>
        {AccountStore.getEnableDailyScheduleBudget() &&
          <div style={{ paddingTop: 30 }}>
            <ScheduleTimeinfoDailyBudget
              readonly={this.props.readonly}
              scheduleBudgetDay={this.state.selectedDayBudget}
              update={(updateDayData) => {
                this.props.handleUpdateDailyBudget(updateDayData, this.state.selectedDay)
              }}
              hierarchyId={this.props.schedule.HierarchyId}
              masterSchedule={this.props.schedule.MasterSchedule}
              autoAddMissingShifts={(shiftTemplate, count) => {
                let patternTemplates = []
                for (let i = 0; i < count; i++) {
                  // shift template selected
                  let shift = _.cloneDeep(shiftTemplate) as IScheduleShift
                  shift = scheduleHelper.overrideShiftTemplateHierarchy(shift, this.props.schedule.HierarchyId, this.props.scheduleJob, this.props.scheduleClient)

                  patternTemplates.push({
                    Id: utils.guid(),
                    Name: shift.Name,
                    HierarchyId: shift.HierarchyId,
                    ShiftTemplates: [shift]
                  } as ISchedulePatternTemplate)
                }

                this.props.handleAutoAddShifts(patternTemplates)
              }}
            />
            {AccountStore.getEnableWorkInstructions() &&
              <WorkInstructions
                readonly={this.props.readonly}
                scheduleBudgetDay={this.state.selectedDayBudget}
                update={(updateDayData) => {
                  this.props.handleUpdateDailyBudget(updateDayData, this.state.selectedDay)
                }}
              />
            }
            <Toggle
              data-intercom-target={`menu-AccountSettings-Mobile-Toggle-ExcludeNonProductiveTime`}
              toggled={this.state.excludeNonProductive}
              onToggle={() => { this.setState({ excludeNonProductive: !this.state.excludeNonProductive }) }}
              labelPosition="left"
              label={strings.View_Only_Productive_Shifts}
              style={{ maxWidth: 300, marginBottom: 15, marginLeft: 5 }}
            />
          </div>
        }
        {this.state.showScheduleTimeinfoDetailDayView &&
          <ScheduleTimeinfoDetailDayView
            readonly={this.props.readonly}
            delaysForDay={delaysForDay}
            patternTemplates={this.state.excludeNonProductive ? patternTemplatesForDay.filter(item => !scheduleHelper.isNonProductive(item)) : patternTemplatesForDay}
            allowDragDrop={this.props.allowDragDrop}
            handleAssignEmployee={this.props.handleAssignEmployee}
            handleUpdateTimelineData={this.props.handleUpdateTimelineData}
            checkValidateNewTimeline={this.props.checkValidateNewTimeline}
            handleDeleteTimelineItem={this.props.handleDeleteTimelineItem}
            handleDeletePatternTemplates={this.props.handleDeletePatternTemplates}
            handleUpdateTimelineItem={this.props.handleUpdateTimelineItem}
            handleAddShiftTemplate={this.props.handleAddShiftTemplate}
            handleShowTimecardPopup={this.props.handleShowTimecardPopup}
            handleUnAssignEmployee={this.props.handleUnAssignEmployee}
            handleDragPatternTemplate={this.props.handleDragPatternTemplate}
            handleDropPatternTemplate={this.props.handleDropPatternTemplate}
            handleOpenCloneDialog={candidateClonePatternTemplates => this.props.handleOpenCloneDialog(candidateClonePatternTemplates, this.state.selectedDay)}
            allowQuickEditTime={this.props.allowQuickEditTime}
            excludeNonProductive={this.state.excludeNonProductive}
            scheduleJob={this.props.scheduleJob}
            scheduleClient={this.props.scheduleClient}
          />
        }
      </div>
    )
  }
}